import { twMerge } from "tailwind-merge";

export interface ToolbarProps {
  className?: string;
  id: string;
  children?: React.ReactNode;
}

export const Toolbar = ({ className = "", id, children }: ToolbarProps) => (
  <div className="sticky top-0 z-70 bg-secondary-900 dark:bg-secondary-950">
    <div
      className={twMerge(
        // Paddings
        "py-2.5",
        // Flex layout
        "flex items-center",
        className
      )}
      data-testid={id}
      id={id}
    >
      {children}
    </div>
  </div>
);
